export default __webpack_public_path__ + "static/media/fauna-docs-2018-p3.616a1f67.png";